



























































































import { Component, Vue } from "vue-property-decorator";
import { listRole, delRole, changeRoleStatus } from "@/api/system/role";
import AddOrEdit from "./addOrEdit.vue";
@Component({
  components: {
    AddOrEdit
  }
})
export default class Department extends Vue {
  public queryParams = {
    pageNum: 1,
    pageSize: 10,
    queryParam:undefined
  };
  public total = 0;
  public addOrEditFlag = true;
  public addOrEditModal = false;
  public list = {};
  public deleteList = [];
  public deleteDialogVisible = false;
  public roleListData = [];
  public item = [];
  public created() {
    this.getListData();
  }
  // 查询表格数据
  public onSubmit() {
    this.getListData();
  }
  // 获取数据接口
  public getListData() {
    listRole(this.queryParams).then(res => {
      this.roleListData = res.rows;
      this.total = res.total;
    });
  }
  /**
   * 新增角色
   */
  get btnStatus(): boolean {
    return this.deleteList.length > 1 ? true : false;
  }
  public addRole() {
    this.addOrEditFlag = true;
    this.addOrEditModal = true;
  }
  /**
   * 删除角色
   */

  public deleteRole() {
    if (this.deleteList && this.deleteList.length === 0) {
      this.$message.error("请至少选择一个您要删除的角色");
    } else {
      this.deleteDialogVisible = true;
    }
  }
  /**
   * 编辑部门
   *  @params {editData} 编辑行数据
   */

  public editRole() {
    if (this.deleteList.length === 0) {
      this.$message.error("请选择您需要编辑的角色");
    } else {
      this.list = this.deleteList[0];
      this.addOrEditModal = true;
      this.addOrEditFlag = false;
    }
  }
  // 关闭新增或编辑部门对话框
  public showDialog(data) {
    this.addOrEditModal = data;
    this.getListData();
  }
  // 选中部门
  public handleSelectionChange(val) {
    this.deleteList = val;
  }
  // 删除选中的部门
  public deleteRoleBtn() {
    const params = [];
    this.deleteList.map(item => {
      params.push(item.roleId);
    });
    delRole(params.join(",")).then(res => {
      this.deleteDialogVisible = false;
      if (res.code === 200) {
        this.$message.success("新增成功");
        this.getListData();
      } else {
        this.$message.error(res.msg);
      }
    });
  }
  // 角色状态修改
  public handleStatusChange(row) {
    const text = row.status === "0" ? "启用" : "停用";
    this.$confirm('确认要"' + text + '""' + row.roleName + '"角色吗?', text, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      cancelButtonClass:'el-button--warning',
      //type: "warning"
    })
      .then(() => {
        return changeRoleStatus(row.roleId, row.status);
        
      })
      .then(() => {
        this.getListData();
        this.$message.success(text + "成功");
      })
      .catch(() => {
        row.status = row.status === "0" ? "1" : "0";
      });
  }
}
